<template>
  <layout-default>
    <div class="container">
      <form @submit.prevent id="checkout-form" class="checkout-form">
        <div class="checkout-breadcrumb border-2 border-bottom">
          <Breadcrumb />
          <h1 class="checkout-title mt-2">{{$t('cart.checkout')}}</h1>
        </div>

        <!-- Step 1: Region Selection and Address -->
        <div v-if="currentStep === 1" class="step-1">
          <div class="row mt-4">
            <div class="col-md-6">
              <div class="form-group mb-4">
                  <BasicLabel
                  class="checkout-label mb-2"
                    :title="$t('checkout.selectRegion')"
                  forInput="region-select"
                />
                <select
                  id="region-select"
                  class="form-select"
                  v-model="selectedRegion"
                >
                  <option value="">{{$t('checkout.selectRegionOption')}}</option>
                  <option
                    v-for="region in regions"
                    :key="region._id"
                    :value="region._id"
                  >
                    {{ region.nome }}
                  </option>
                </select>
              </div>

              <div class="form-group mb-4">
                <BasicLabel
                  class="checkout-label mb-2"
                  :title="$t('checkout.paymentMethod')"
                  forInput="payment-method"
                />
                <select
                  id="payment-method"
                  class="form-select"
                  v-model="selectedPaymentMethod"
                >
                  <option value="">{{$t('checkout.selectAddressOption')}}</option>
                  <option
                    v-for="method in paymentMethods"
                    :key="method._id"
                    :value="method._id"
                  >
                    {{ method.name }}
                  </option>
                </select>
              </div>

              <div class="form-group mb-4">
                <BasicLabel
                  class="checkout-label mb-2"
                  :title="$t('checkout.shippingAddress')"
                  forInput="shipping-address"
                />
                <BasicInputText v-model="selectedAddress" :placeholder="$t('checkout.shippingAddressPlaceholder')" required :hasFocus="false" class="radius focus form-control fw-light pt-4 pb-4"/>

                <!-- <select
                  id="shipping-address"
                  class="form-select"
                  v-model="selectedAddress"
                >
                  <option value="">Select an Address</option>
                  <option
                    v-for="address in addresses"
                    :key="address"
                    :value="address"
                  >
                    {{ address }}
                  </option>
                </select> -->
              </div>

              <div class="mt-4">
                <ButtonFilled
                  :hasRoundedCorners="true"
                  text="Continue to Shipping Options"
                  @click="proceedToStep2"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- Step 2: Shipping Options -->
        <div v-if="currentStep === 2" class="step-2">
          <div class="shipping-options mt-4">
            <div v-for="item in $store.state.cart.items" :key="item._id" class="cart-item mb-4 p-4 border rounded">
            <!-- <div v-for="item in shippingOptions" :key="shipItem.elementoId" class="cart-item mb-4 p-4 border rounded"> -->
              <div class="row">
                <div class="col-8">
                  <div class="col col-7 d-flex align-items-center flex-row">
                    <div class="title-image overflow-hidden justify-content-center d-flex align-items-center">
                      <link-wrapper :location="getLocation" :removeDecorations="true">
                        <img v-if="item.productVariant.immagine && item.productVariant.immagine.length > 0 && item.productVariant.immagine[0].path" class="item-img ms-4" :src="$getFileSource(item.productVariant.immagine[0].path)" :alt="item.nome" />
                      </link-wrapper>
                    </div>
                    <div class="col item-title col-5 ms-5 d-block align-items-center">
                      <!-- ProdctTitle -->
                      <div class="mobile-title d-flex justify-content-between ">
                        <span class="subtitle-responsive fs-5 text-dark fw-bold"
                          >{{$t('cart.product')}}</span
                        >
                        <span class="fs-5 text-dark fw-md-light title">
                          <link-wrapper :location="getLocation" :removeDecorations="true">
                            {{ item.nome }}</link-wrapper
                          ></span
                        >
                      </div>
                      <!-- Product Vendor -->
                      <div v-if="item.vendor" class="vendor-title d-flex justify-content-between">
                        <span class="subtitle-responsive text-secondary">{{$t('cart.vendor')}}</span>
                        <span class=" vendor text-secondary"> {{ item.vendor }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col col-5 item-price  d-flex justify-content-around">
                    <!-- Product price/piece -->
                    <div
                      class="mobile-title d-flex align-items-center justify-content-between"
                    >
                      <span class="subtitle fs-6 text-dark fw-bold">{{$t('product.price')}}:</span>
                      <span
                        ><b>{{ $convertCurrency(item.prezzoUnitario) }}</b> {{$t('cart.perPiece')}}</span
                      >
                    </div>
                    <!-- Product Quantity -->
                    <div
                      class="mobile-title d-flex align-items-center justify-content-between"
                    >
                      <span class="subtitle fs-6 text-dark fw-bold">{{$t('cart.quantity')}}</span>
                      <span>{{ item.qty }}</span>
                    </div>

                    <!-- Total -->
                    <div
                      class="mobile-title d-flex align-items-center justify-content-between"
                    >
                      <span class="subtitle fs-6 text-dark fw-bold">{{$t('cart.total')}}</span>
                      <span
                        ><b>{{ $convertCurrency(item.qty * item.prezzoUnitario) }}</b> {{$t('cart.inTotal')}}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-4 d-flex flex-column justify-content-center align-items-center shipping-option-select">
                  <BasicLabel
                    class="checkout-label mb-2"
                    :title="$t('checkout.selectShippingOption')"
                    :forInput="'shipping-' + item._id"
                  />
                  <select
                    :id="'shipping-' + item._id"
                    class="form-select"
                    v-model="shippingOptions[item._id]"
                  >
                    <option value="">{{$t('checkout.selectShippingOptionPlaceholder')}}</option>
                    <option
                      v-for="option in shippingOptionsList.find(opt => opt.elementoId === item._id)?.opzioni"
                      :key="option._id"
                      :value="option._id"
                    >
                      {{ option.nome }} - {{ $convertCurrency(option.prezzo) }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between mt-4">
            <ButtonFilled
              :hasRoundedCorners="true"
              :text="$t('forms.back')"
              @click="currentStep = 1"
            />
            <ButtonFilled
              :hasRoundedCorners="true"
              :text="$t('checkout.order')"
              @click="makeOrderCloseCart"
            />
          </div>
        </div>
      </form>
    </div>
  </layout-default>
</template>
<script>
import { countries } from "../../data/countries.json";
import LayoutDefault from "../../components/organisms/LayoutDefault/LayoutDefault.vue";
import Breadcrumb from "../../components/atoms/Breadcrumb/Breadcrumb.vue";
import ButtonFilled from "../../components/atoms/Button/ButtonFilled.vue";
import BasicLabel from "../../components/atoms/FormInput/BasicLabel.vue";

import Vue from "../../main";
import { addAddress, addPaymentMethod, addShipping, getPaymentMethods, getRegions, getShippingOptions } from "../../composables/manageCheckout";
import { closeCart, regenerateCart } from "../../composables/manageCart";
import BasicInputText from "../../components/atoms/FormInput/BasicInputText.vue";

const { $toast } = Vue._context.config.globalProperties;

export default {
  beforeCreate() {
    document.title = "Checkout - viabrera";
  },
  mounted() {
  },
  components: {
    LayoutDefault,
    Breadcrumb,
    ButtonFilled,
    BasicLabel,
    BasicInputText,
  },
  data() {
    return {
      currentStep: 1,
      selectedRegion: null,
      // addresses: [],
      selectedAddress: null,
      regions: [],
      shippingOptions: {},
      shippingOptionsList: [],
      paymentMethods: [],
      selectedPaymentMethod: null,
      countries,
      cartSummary: this.$store.state.cart.cartSummary,
      // cart: this.$store.state.cart.items,
    };
  },
  methods: {
    async fetchRegions() {
      try {
        const response = await getRegions(100);
        this.regions = response.regioni || [];
        this.selectedRegion = this.regions?.[0]?._id || null;
      } catch (error) {
        console.error("Error fetching regions:", error);
      }
    },
    // async fetchAddress() {
    //   try {
    //     const response = await getAddresses();
        
    //     this.addresses = response?.indirizziSpedizione || [];
    //     this.selectedAddress = this.addresses?.[0] || null;
    //   } catch (error) {
    //     console.error("Error fetching regions:", error);
    //   }
    // },
    async fetchPaymentMethods() {
      try {
        const response = await getPaymentMethods();
        this.paymentMethods = response?.metodipagamento || [];
        this.selectedPaymentMethod = this.paymentMethods?.[0]?._id || null;
      } catch (error) {
        console.error("Error fetching regions:", error);
      }
    },
    async fetchShippingOptions() {
      if (!this.selectedRegion || !this.selectedAddress ) return;
      
      try {
        const response = await getShippingOptions(this.selectedRegion);
        this.shippingOptionsList = response.risposta || [];

        // Auto select the first shipping option for each item
        this.shippingOptions = this.shippingOptionsList.reduce((acc, opt) => {
          acc[opt.elementoId] = opt.opzioni?.[0]?._id || "";
          return acc;
        }, {});

      } catch (error) {
        console.error("Error fetching shipping options:", error);
      }
    },
    async proceedToStep2() {
      if (!this.selectedRegion || !this.selectedAddress || !this.selectedPaymentMethod) {
        $toast.error("Please select a region, address, and payment method before proceeding.");
        return;
      }
      var paymentAdded = await addPaymentMethod(this.selectedPaymentMethod);
      if(!paymentAdded){
        $toast.error("Failed to add payment method. Please try again.");
        return;
      }
      
      var addressAdded = addAddress(this.selectedAddress);
      if (!addressAdded) {
        $toast.error("Failed to add address. Please try again.");
        return;
      }
      
      await this.fetchShippingOptions();
      this.currentStep = 2;
    },
    async makeOrderCloseCart() {
      var anyNonSelected = Object.values(this.shippingOptions).some((val) => 
        val == "" ||
        val == null
      );
      if(anyNonSelected){
        $toast.error("Please select all shipping options.");
        return;
      }
      var shipRes = await addShipping(this.shippingOptions);
      if(shipRes){
        let {cartSummary} = await closeCart();
        if(cartSummary){
          await regenerateCart();
        }
        if(cartSummary.linkPagamento) {
          window.location.href = cartSummary.linkPagamento;
        }
      }
      else {
        $toast.error("Failed to creat order. Please try again.");
      }
    }
  },
  created() {
    this.fetchRegions();
    // this.fetchAddress();
    this.fetchPaymentMethods();
  },
};
</script>


<style scoped="scoped">
.cart-item {
  width: 100%;
  box-shadow: 0px 0px 25px rgb(0 0 0 / 10%);
  margin: 0px;
}
.item-img {
  width: 80px;
  height: auto;
}
.fa-times {
  color: var(--primary-color);
  font-size: 30px;
}
.title-image {
  height:80px;
}
.fa-times:hover {
  color: #d3d3d3;
  cursor: pointer;
}
.form-select {
  border: 1px solid #ddd;
  border-radius: 30px;
  padding: 10px 20px;
  width: 100%;
  font-size: 15px;
  color: #606060;
}

.form-select:focus {
  outline: none;
  box-shadow: none;
  border-color: #242424;
}
.checkout-form{
  margin-top: 20px;
  margin-bottom: 20px;
}
  .checkout-textarea {
  border: 1px solid#ddd;
  border-radius: 30px;
}
.checkout-textarea-label {
  font-size: 16px !important;
  color: #242424;
  font-weight:500;
}
.checkout-textarea {
  padding: 20px;
}
.checkout-textarea::placeholder {
  font-size: 15px;
}
@media (max-width: 767.98px) {
  .mobile-title {
    margin-top: 15px;
  }
  .vendor-title,
  .mobile-title {
    width: 100%;
  }
  /* .item-img {
    display: none !important;
  } */
  .cart-item {
    display: block !important;
  }
  .item-title,
  .item-price {
    display: flex !important;
    flex-direction: column;
  }
  .vendor {
    display: flex !important;
    flex-direction: row !important;
  }
  .col-7,
  .col-5 {
    width: 100%;
  }
  .product-title {
    padding: 0px !important;
  }
  .col-7 {
    display: flex !important;
    flex-direction: column !important;
    justify-content: flex-start;
  }
  .item-title {
    padding: 0px !important;
    margin: 0px !important;
  }
  .vendor {
    justify-content: space-between;
  }
  .subtitle {
    font-size: 14px !important;
  }
  .item-cart {
    padding: 20px 6px 20px !important;
  }
  .shipping-option-select{
    justify-content: end !important;
  }
}

@media screen and (min-width: 768px) {
  .subtitle-responsive,
  .subtitle {
    display: none;
  }
  .title {
    font-weight: 600;
  }
}
</style>
